import ResetPassword from "../reset-password/ResetPasswordPage";

export const ResetPasswordPageConfig = {
  routes: [
    {
      path: "/pages/auth/reset-password/:resetToken",
      exact: true,
      component: ResetPassword,
      processing: true,
    },
  ],
};
